<template>
    <div class="layer-report-line" :data-id="id" :data-layout-type="node?.layout?.type">
        <!-- Modo visualização -->
        <div class="layer-report-line__header">
            <span class="title">{{ node.report.text || node.layout.caption }}</span>
        </div>
        <div class="layer-report-line__content">
            <section class="children">
                <template v-if="execMode == gConsts.rt.execModes.WORK">
                    <DraggableList :items="childrenReportNodes" :item-key="labelItemKey" :draggable="canReorder"
                        @reorder="onReorderLabels">
                        <template #default="{ item }">
                            <template v-if="item.layout.type == gConsts.node.layout.types.LABEL">
                                <labelReportLineCMP :execMode="execMode" :reportNode="item" :id="item.id"
                                    :active="activeNode ? activeNode?.label == item.id : false" :canEdit="canEdit" />
                                <template v-if="canInsertCustomLineAfterLabel(item) && canEdit">
                                    <custom-line-placeholder :orderIndex="item.order.index" :parent="node.id" />
                                </template>
                            </template>
                            <template v-if="item.layout.type == gConsts.node.layout.types.CUSTOM_LINE">
                                <customReportLineCMP :execMode="execMode" :reportCustomLine="item" :id="item.id" :canEdit="canEdit" />
                            </template>
                        </template>
                    </DraggableList>
                </template>
                <template v-else>
                    <template v-for="item in validatedChildrenReportNodes">
                        <template v-if="item.layout.type == gConsts.node.layout.types.LABEL">
                            <labelReportLineCMP :key="item.id" :execMode="execMode" :reportNode="item" :id="item.id"
                                :active="activeNode ? activeNode?.label == item.id : false" :canEdit="canEdit" />
                            <template v-if="canInsertCustomLineAfterLabel(item) && canEdit">
                                <custom-line-placeholder :key="`placeholder-${item.id}`" :orderIndex="item.order.index" :parent="node.id" />
                            </template>
                        </template>
                        <template v-if="item.layout.type == gConsts.node.layout.types.CUSTOM_LINE">
                            <customReportLineCMP :key="item.id" :execMode="execMode" :reportCustomLine="item" :id="item.id" :canEdit="canEdit" />
                        </template>
                    </template>
                </template>
            </section>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import labelReportLineCMP from './labelReportLine.vue';
import DraggableList from '@/components/ui/draggableList.vue';
import customReportLineCMP from './customReportLine.vue';
import customLinePlaceholder from './custom/customLinePlaceholder.vue';

import { gConsts } from '@/globals/gConsts';

export default {
    name: 'layerReportLineCMP',
    components: {
        labelReportLineCMP,
        DraggableList,
        customReportLineCMP,
        customLinePlaceholder,
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        node: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        activeNode: {
            type: Object,
            default: null
        },
        canEdit: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            gConsts: gConsts,
            isActive: this.activeNode != null,
        }
    },

    methods: {
        ...mapActions([
            'ACT_report_updateLayerOrderList',
        ]),
        labelItemKey(item) {
            return item.id;
        },

        onReorderLabels(items) {
            console.log('onReorderLabels: items: ', JSON.stringify(items));
            this.ACT_report_updateLayerOrderList({
                layerId: this.node.id,
                orderList: items.map(item => item.id)
            });
        },

        canInsertCustomLineAfterLabel(labelNode) {
            const foundIndex = this.childrenReportNodes.findIndex(node => node.id == labelNode.id);
            if (foundIndex == -1) {
                return false;
            }

            if (this.childrenReportNodes[foundIndex + 1]?.layout?.type == gConsts.node.layout.types.CUSTOM_LINE) {
                return false;
            }

            return true;
        }
    },

    watch: {
        activeNode(newVal) {
            this.isActive = newVal != null;
        }
    },

    computed: {
        ...mapGetters([
            'GET_nodesArray',
            'GET_reportNodes',
            'GET_reportNodes_validated',
        ]),

        canReorder() {
            return this.execMode === gConsts.rt.execModes.WORK && 
                this.canEdit &&
                this.childrenReportNodes.length > 1;
        },

        children() {
            return this.GET_nodesArray.filter(node => (node.layout.parent === this.node.id));
        },

        childrenReportNodes() {
            const childrenReportNodes = this.GET_reportNodes.filter(reportNode => reportNode.layout.parent === this.node.id);
            return childrenReportNodes.sort((a, b) => a.order.index - b.order.index);
        },

        validatedChildrenReportNodes() {
            const childrenReportNodes = this.GET_reportNodes_validated.filter(reportNode => reportNode.layout.parent === this.node.id);
            return childrenReportNodes.sort((a, b) => a.order.index - b.order.index);
        },
    }
}
</script>

<style scoped>
@import '../../styles/shared/reportLine/layer_report_line.css';

#relatorio[data-exec-mode="work"] .layer-report-line {
    gap: var(--spacing-xs);
    padding-left: var(--spacing);
}

#relatorio[data-exec-mode="work"] .layer-report-line__content {
    padding-block: var(--spacing-xs);
    padding-left: 0;
}

#relatorio[data-exec-mode="work"] .layer-report-line__content>.children {
    gap: var(--spacing-sm);
}

.layer-report-line__header {
    cursor: default;
}
</style>
